import rangeMap from '@lib/range-map'
import InfiniteScroll from '@components/ui/InfiniteScroll'
import {
  IMG_PLACEHOLDER,
  TITLE_PRODUCTS,
} from '@components/utils/textVariables'
import { IExtraProps } from '@components/common/Layout/Layout'
import NewProductCard from '../ProductCard/NewProductCard'
import { groupBy } from '@framework/utils/lodash'
import {
  EmptyGuid,
  PLP_APP_BANNER_CLICK_URL,
  PLP_BANNER_1,
  PLP_BANNER_2,
  PLP_BANNER_3,
  PLP_BANNER_4,
  PLP_BANNER_5,
} from '@components/utils/constants'
import Link from 'next/link'
import IntersectionObserverComponent, {
  IBannerData,
} from '@components/utils/IntersectionObserverComponent'
import { getCurrentPage, getImageNameFromURL, getMinHeights } from '@framework/utils/app-util'
import { useUI } from '@components/ui'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { recordGA4Event } from '@components/services/analytics/ga4'
import { getMidBannersHandler } from './helper'

interface Props {
  products: any
  currentPage: number | string
  handlePageChange?: any
  handleInfiniteScroll: any
  collectionName: any
  collectionId: any
  routerFilters?: any
  pageType?: any
  dynamicLink?: string
  setQuickViewProductSlug: (payload: string | null) => void
  isFromSearch?: boolean
  showSizePopup?: any
  buttonConfig?: any
  mid1Banners?: Array<any>
  mid2Banners?: Array<any>
  mid3Banners?: Array<any>
}

export default function Grid({
  products,
  currentPage,
  setQuickViewProductSlug,
  handleInfiniteScroll,
  collectionName,
  collectionId,
  routerFilters = null,
  deviceInfo,
  dynamicLink,
  isFromSearch = false,
  showSizePopup,
  buttonConfig,
  mid1Banners,
  mid2Banners,
  mid3Banners,
}: Props & IExtraProps) {
  const IS_INFINITE_SCROLL =
    process.env.NEXT_PUBLIC_ENABLE_INFINITE_SCROLL === 'true'

  const { isOnlyMobile } = deviceInfo
  const { user } = useUI()

  // const handleBannerClick = (bannerData: IBannerData) => {
  //   const currentPage = getCurrentPage()
  //   if (currentPage) {
  //     recordGA4Event(window, GA_EVENT.BANNER_CLICK, {
  //       ...bannerData,
  //       current_page: currentPage,
  //       loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
  //     })
  //   }
  // }

  return (
    <>
      <section
        aria-labelledby="products-heading"
        className="mx-auto overflow-hidden max-w-7xl sm:px-6 lg:px-6 min-h-[506px]"
      >
        {IS_INFINITE_SCROLL && (
          <InfiniteScroll
            fetchData={handleInfiniteScroll}
            total={products?.total}
            currentNumber={products?.results?.length}
            component={
              <div
                className={`grid grid-cols-2 w-full sm:gap-y-1 sm:mr-3 sm:ml-3 md:grid-cols-4 product-listing-main ${
                  products?.results?.length < 5
                    ? `lg:grid-cols-4`
                    : 'lg:grid-cols-4'
                }`}
                style={{ margin: '0' }}
              >
                {!products?.results?.length &&
                  Number(currentPage) > 1 &&
                  rangeMap(12, (i) => (
                    <div
                      key={i}
                      className="mx-auto mt-20 rounded-md shadow-md w-60 h-72"
                    >
                      <div className="flex flex-row items-center justify-center h-full space-x-5 animate-pulse">
                        <div className="flex flex-col space-y-3">
                          <div className="w-full h-48 bg-gray-100 rounded-md "></div>
                          <div className="h-6 mt-40 bg-gray-100 rounded-md w-36 "></div>
                        </div>
                      </div>
                    </div>
                  ))}
                {products?.results?.map((product: any, productIdx: number) => {
                  const redirectLink = PLP_APP_BANNER_CLICK_URL
                  const getBannerNumber = (index: number): number =>
                    (index / 8) % 5
                  const getBannerUrl = (index: number) => {
                    const bannerNumber = getBannerNumber(index)
                    if (bannerNumber === 1) {
                      return PLP_BANNER_1
                    } else if (bannerNumber === 2) {
                      return `${PLP_BANNER_2}`
                    } else if (bannerNumber === 3) {
                      return PLP_BANNER_3
                    } else if (bannerNumber === 4) {
                      return `${PLP_BANNER_4}`
                    } else if (bannerNumber === 0) {
                      return PLP_BANNER_5
                    } else {
                      return PLP_BANNER_1
                    }
                  }
                  const getBannerLink = (index: number): string => {
                    const bannerNumber = getBannerNumber(index)
                    if (bannerNumber === 1 || bannerNumber === 0) {
                      return '/my-account/referral'
                    } else if (bannerNumber === 2 || bannerNumber === 3) {
                      return '/my-account/referral'
                    } else if (bannerNumber === 4) {
                      return '/my-account/referral'
                    } else {
                      return dynamicLink ?? redirectLink
                    }
                  }

                  const { plpmsg1Height, plpmsg3Height } = getMinHeights(isOnlyMobile, productIdx, product, products);
                  const componentType = 'image'
                  const image = getBannerUrl(productIdx) || IMG_PLACEHOLDER

                  const bannerData: IBannerData = {
                    position: 0,
                    banner_name: image ? getImageNameFromURL(image) : '',
                    component_type: componentType,
                    component_name: 'Collection Banner',
                    url: image ?? '',
                  }
                  return (
                    <>
                      {productIdx % 8 === 0 &&
                        productIdx !== 0 &&
                        !isFromSearch &&
                        isOnlyMobile && (
                          <div
                            className="col-span-2 mt-2"
                            // onClick={() => {
                            //   handleBannerClick(bannerData)
                            // }}
                          >
                            {getMidBannersHandler({
                              productIdx,
                              user,
                              mid1Banners,
                              mid2Banners,
                              mid3Banners,
                            })}
                          </div>
                        )}
                      <NewProductCard
                        key={productIdx}
                        product={product}
                        collectionName={collectionName}
                        position={productIdx + 1}
                        collectionId={collectionId}
                        routerFilters={routerFilters}
                        deviceInfo={deviceInfo}
                        currentPageNumber={currentPage}
                        _plpmsg1Height={plpmsg1Height}
                        _plpmsg3Height={plpmsg3Height}
                        setQuickViewProductSlug={setQuickViewProductSlug}
                        isFromSearch={isFromSearch}
                        showSizePopup={showSizePopup}
                      />
                    </>
                  )
                })}
              </div>
            }
          />
        )}
      </section>
    </>
  )
}
